import React, { useState } from 'react';
import './contact.css';
import emailjs from 'emailjs-com';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs.sendForm('default_service', 'template_74ienqs', e.target, 'PRb_GDLhvtr54sgUl')
      .then((result) => {
        console.log(result.text);
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
        setTimeout(() => setStatus(null), 3000);
      }, (error) => {
        console.log(error.text);
        setStatus('error');
        setTimeout(() => setStatus(null), 3000);
      });
  };

  return (
    <div className="ContactPage">
      <h2>Contact Me</h2>

      <div className="ContactForm">
        <form onSubmit={handleSubmit} id="form">
          <div className="form-group">
            <label className="field-label" htmlFor="name">Your Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
              required
            />
          </div>

          <div className="form-group">
            <label className="field-label" htmlFor="email">Your Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label className="field-label" htmlFor="phone">Your Phone (Optional)</label>
            <input
              type="text"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number (optional)"
            />
          </div>

          <div className="form-group">
            <label className="field-label" htmlFor="message">Your Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Write your message here"
              rows="6"
              required
            />
          </div>

          <button 
            type="submit" 
            id="button" 
            className={status ? `status-${status}` : ''}
            disabled={status === 'sending'}
          >
            {status === 'sending' && 'Sending...'}
            {status === 'success' && 'Message Sent Successfully!'}
            {status === 'error' && 'Failed! Please Try Again'}
            {!status && 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;